export const GET_RESTAURANTS_LIST_REQUEST="GET_RESTAURANTS_LIST_REQUEST"
export const GET_RESTAURANTS_LIST_SUCCESS="GET_RESTAURANTS_LIST_SUCCESS"
export const GET_RESTAURANTS_LIST_FAILURE="GET_RESTAURANTS_LIST_FAILURE"
